import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const ApprovedListingDetailsMain: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    const formatDateForInput = (timestamp: number) => {
        if (!timestamp || isNaN(timestamp)) return '';
        try {
            const date = new Date(timestamp);
            if (isNaN(date.getTime())) return '';

            const month = date.getMonth() + 1; // No padding with zeros
            const day = date.getDate(); // No padding with zeros
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch {
            return '';
        }
    };
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="mb-13">
                        <h1 className="mb-3 fs-3 fw-bold">Order Information</h1>
                    </div>

                    <div className="table-responsive">
                        {/* <h3>Listing Information</h3> */}
                        {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Grade</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Color</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Packaginng</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Qty (kg)</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Price (INR/Kg)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.grade || 'N/A'}
                                        </span>
                                    </td>
                                    <td className="ps-4">
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.color || 'N/A'}
                                        </span>
                                    </td>

                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.packagingType || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.quantity || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.price || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}
                        {/* <div className="table-responsive">
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "20px",
                                border: "1px solid #ddd"
                            }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2} style={{
                                            backgroundColor: "#BFD7ED",
                                            color: "black",
                                            fontWeight: "bold",
                                            padding: "12px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Listing Information
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "30%", padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>Grade</td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.orderDetail?.[0]?.items?.[0]?.grade || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>Color</td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.orderDetail?.[0]?.items?.[0]?.color || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>Packaging</td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.packagingType || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>Qty (Kg)</td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.orderDetail?.[0]?.items?.[0]?.quantity || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>Price (INR/Kg)</td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.orderDetail?.[0]?.items?.[0]?.price || 'N/A'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> */}

                    </div>


                    <div className="table-responsive">
                        {/* <h3>Verification Information</h3> */}
                        {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Grade</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Color</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Packaginng</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Qty (Kg)</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Price (INR/Kg)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.verifiedOrderDetails[0]?.items[0]?.grade || 'N/A'}
                                        </span>
                                    </td>
                                    <td className="ps-4">
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.verifiedOrderDetails[0]?.items[0]?.color || 'N/A'}
                                        </span>
                                    </td>

                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.verifiedOrderDetails[0]?.items[0]?.quantity || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.verifiedOrderDetails[0]?.items[0]?.price || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}

                        {/* <div className="table-responsive">
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "20px",
                                border: "1px solid #ddd"
                            }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2} style={{
                                            backgroundColor: "#BFD7ED",
                                            color: "black",
                                            fontWeight: "bold",
                                            padding: "12px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Verification Information
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{
                                            width: "30%",
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Grade
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.verifiedOrderDetails?.[0]?.items?.[0]?.grade || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                            Color
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.verifiedOrderDetails?.[0]?.items?.[0]?.color || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                            Packaging
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                            Qty (Kg)
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.verifiedOrderDetails?.[0]?.items?.[0]?.quantity || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                            Price (INR/Kg)
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user.verifiedOrderDetails?.[0]?.items?.[0]?.price || 'N/A'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> */}

                    </div>












                    {/* <div className="table-responsive mt-8">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Verification Images</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex gap-4 flex-wrap">
                                            {user.images?.filter(img => img.docType === 'VERIFIED_DOC').map((img, index) => (
                                                <div key={index} className="text-center">
                                                    <img
                                                        src={img.docUrl}
                                                        alt={`Verification Document ${index + 1}`}
                                                        className="h-150px w-150px object-cover rounded cursor-pointer"
                                                        style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                        onClick={() => window.open(img.docUrl, '_blank')}
                                                        onError={(e) => {
                                                            e.currentTarget.src = '/media/avatars/blank.png';
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                            {!user.images?.some(img => img.docType === 'VERIFIED_DOC') && (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}

                    <div className="table-responsive">
                        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "25%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Order Information</th>
                                    <th style={{ width: "25%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Listing Info</th>
                                    <th style={{ width: "25%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Verified Info</th>
                                    <th style={{ width: "25%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Approved Info</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold",
                                        }}
                                    >

                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <img
                                                src={user?.verifiedOrderDetails?.[0]?.categoryIcon} // replace with your image path
                                                alt="Category"
                                                style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    objectFit: "contain",
                                                    borderRadius: "50%"
                                                }}
                                            />
                                            <span>Category</span>

                                        </div>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.categoryName || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {user?.verifiedOrderDetails?.[0]?.categoryName || 'N/A'}
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {user?.confirmedOrderDetails?.[0]?.categoryName || 'N/A'}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <img
                                                src={user?.verifiedOrderDetails?.[0]?.items?.[0]?.itemIcon} // replace with your image path
                                                alt="Category"
                                                style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    objectFit: "contain",
                                                    borderRadius: "50%"
                                                }}
                                            />
                                            <span>Item</span>

                                        </div>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.items?.[0]?.itemName || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {user?.verifiedOrderDetails?.[0]?.items?.[0]?.itemName || 'N/A'}
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {user?.confirmedOrderDetails?.[0]?.items?.[0]?.itemName || 'N/A'}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <img
                                                src={user?.verifiedOrderDetails?.[0]?.items?.[0]?.itemIcon} // replace with your image path
                                                alt="Category"
                                                style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    objectFit: "contain",
                                                    borderRadius: "50%"
                                                }}
                                            />
                                            <span>Grade</span>

                                        </div>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.items?.[0]?.grade || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.verifiedOrderDetails?.[0]?.items?.[0]?.grade || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.confirmedOrderDetails?.[0]?.items?.[0]?.grade || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <img
                                                src={user?.verifiedOrderDetails?.[0]?.items?.[0]?.itemIcon} // replace with your image path
                                                alt="Category"
                                                style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    objectFit: "contain",
                                                    borderRadius: "50%"
                                                }}
                                            />
                                            <span>Color</span>

                                        </div></td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.items?.[0]?.color || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.verifiedOrderDetails?.[0]?.items?.[0]?.color || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.confirmedOrderDetails?.[0]?.items?.[0]?.color || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}> <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <img
                                            src={user?.verifiedOrderDetails?.[0]?.items?.[0]?.itemIcon} // replace with your image path
                                            alt="Category"
                                            style={{
                                                width: "18px",
                                                height: "18px",
                                                objectFit: "contain",
                                                borderRadius: "50%"
                                            }}
                                        />
                                        <span>Packaging</span>

                                    </div></td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.packagingType || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{'-'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.confirmedOrderDetails?.[0]?.packagingType || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <img
                                                src={user?.verifiedOrderDetails?.[0]?.items?.[0]?.itemIcon} // replace with your image path
                                                alt="Category"
                                                style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    objectFit: "contain",
                                                    borderRadius: "50%"
                                                }}
                                            />
                                            <span>Quantity (Kg)</span>

                                        </div></td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.items?.[0]?.quantity || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user.verifiedOrderDetails?.[0]?.items?.[0].remainingQuantity || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.confirmedOrderDetails?.[0]?.items?.[0]?.quantity || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>

                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <img
                                                src={user?.verifiedOrderDetails?.[0]?.items?.[0]?.itemIcon} // replace with your image path
                                                alt="Category"
                                                style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    objectFit: "contain",
                                                    borderRadius: "50%"
                                                }}
                                            />
                                            <span>Price (INR/Kg)</span>

                                        </div></td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.items?.[0]?.price || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user.verifiedOrderDetails?.[0]?.items?.[0].price || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.confirmedOrderDetails?.[0]?.items?.[0]?.price || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}> <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <img
                                            src={user?.verifiedOrderDetails?.[0]?.items?.[0]?.itemIcon} // replace with your image path
                                            alt="Category"
                                            style={{
                                                width: "18px",
                                                height: "18px",
                                                objectFit: "contain",
                                                borderRadius: "50%"
                                            }}
                                        />
                                        <span>Delivery Date</span>

                                    </div></td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{formatDateForInput(user?.deliveryDate) || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{formatDateForInput(user.deliveryDate) || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{formatDateForInput(user?.deliveryDate) || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed'
                        }}>
                            <thead >
                                <tr >
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Listing Verification Info</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <table style={{ width: '100%', }}>
                                            <thead>
                                                <tr>
                                                    <th>Verified By</th>
                                                    <th>Date</th>
                                                    <th>Remarks</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{user?.verifiedBy || 'N/A'}</td>
                                                    <td>{new Date(Number(user?.verifiedAt)).toLocaleDateString() || 'N/A'}</td>
                                                    <td>{user?.remarks || 'N/A'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed'
                        }}>
                            <thead >
                                <tr >
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Order Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <table style={{ width: '100%', }}>
                                            <thead>
                                                <tr>
                                                    <th>Steps</th>
                                                    <th>Remarks</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{'Listing Info'}</td>
                                                    <td>{user?.creationRemarks || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>{'Verified Info'}</td>
                                                    <td>{user?.verificationRemarks || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>{'Approved Info'}</td>
                                                    <td>{user?.approvalRemarks || 'N/A'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-responsive mt-8">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Listed Images</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex gap-4 flex-wrap">
                                            {user.images?.filter(img => img.docType === 'MATERIAL_DOC' || img.docType === 'SALE_DOC').map((img, index) => (
                                                <div key={index} className="text-center">
                                                    <img
                                                        src={img.docUrl}
                                                        alt={`${img.docType === 'MATERIAL_DOC' ? 'Material' : 'Sale'} Document ${index + 1}`}
                                                        className="h-150px w-150px object-cover rounded cursor-pointer"
                                                        style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                        onClick={() => window.open(img.docUrl, '_blank')}
                                                        onError={(e) => {
                                                            e.currentTarget.src = '/media/avatars/blank.png';
                                                        }}
                                                    />
                                                    {/* <p className="mt-2 text-sm font-medium">{img.docType === 'MATERIAL_DOC' ? 'Material Document' : 'Sale Document'}</p> */}
                                                </div>
                                            ))}
                                            {/* {!user.images?.some(img => img.docType === 'VERIFIED_DOC') && (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )} */}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>




                    <div className="table-responsive mt-8">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Purchase Order</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex gap-4 align-items-center">
                                            {user.images?.filter(img => img.docType === 'PO_IMAGE').map((img, index) => (
                                                <div key={index} className="d-flex align-items-center">
                                                    <i
                                                        className="bi bi-file-pdf text-danger cursor-pointer"
                                                        style={{ fontSize: '3rem' }}
                                                        onClick={() => window.open(img.docUrl, '_blank')}
                                                        title="View PDF"
                                                    ></i>
                                                </div>
                                            ))}
                                            {!user.images?.some(img => img.docType === 'PO_IMAGE') && (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>





                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};